// language-en.js
module.exports = {
    home: {
        nav1: "Homepage",
        nav2: "Product",
        nav3: "DEMO",
        nav4: "Company",
        nav5: "Introduction",
        nav6: "About US",
        nav7: "Contact US",
        nav8: "About",
        nav9: "Service",
        nav10: "Privacy Policy",
        nav11: "Product introduction",
        nav12: "Follow us",
        nav13: "Scan and to know more about us",
        nav14: "Follow Neuralimage",
        title: "Neuralimage",
        title1: "Expert in the field of AI image generation",
        btn: "Experience immediately",
        title2: "professional team",
        title3: "Mature Technology",
        title4: "Global Resource guarantee",
        tips: "Based on advanced artificial intelligence technology, it accurately and efficiently identifies the user's facial information, such as face shape, hair color, length, hair volume, gender, skin color and other information, combined with the target image, to generate a real and effective image reference.",
        tips1: "The core members of Intelligent are computer vision PHDS from New York University, Portland State University, the University of Oregon, Prude University, Ohio State University, and Nanyang Technological University. ",
        tips2: "The team has been immersed in the field of AI for many years, and has a perfect knowledge system and mature technology in the fields of artificial intelligence, computer vision and computer graphics. At present, the technology has been fully implemented, and the related products have been gradually put into the market. ",
        tips3: "We have reliable partners in many parts of the world. For example, we expect to make progress together with our partners, and empower with AI to make life easier. ",
        title5: "partners",
        title6: "CAS(Chinese Academy of Sciences)",
        tips4: "China's Top academic institution for Natural Sciences, the Top consulting institution for Science and Technology, and the Center for Comprehensive Research and Development of Natural Sciences and High Technology. ",
        tips5: "(Mogasi road) is the perfect combination of innovative culture media and information technology company, sole entire case take the national project 'dunhuang mogao grottoes protection project' of the creative planning, tourist center display form and content design, tourist route design and planning, the mogao grottoes cave digital cinema, ball screen and the giant-screen film make grinders and other special cinema construction consulting work.  It has become a classic case of World Cultural Heritage protection and utilization. ",
        title7: "New Hair Style generation",
        title8: "Advantages",
        title9: "Beijing Mogao Silk Road Cultural Development Co., Ltd",
        icp: "Beijing ICP Record Number 2022018834-1"
    },
    product: {
        ios: "iOS",
        az: "Android",
        ios1:"iOS",
        az1: "Android",
        title: "AI power, one-click generation,",
        title6: "to create the hair metaverse era",
        title1: "What is MetaStyle?",
        tips: "To provide the user with image generation function, the user by uploading image → select the target image, can be generated by a key, let the user a key to find their own image.",
        title2: "What are the advantages of Metastyle",
        tips1: "Based on advanced artificial intelligence technology, it accurately and efficiently identifies the user's facial information, such as face shape, hair color, length, hair volume, gender, skin color and other information, combined with the target image, to generate a real and effective image reference. ",
        title3: "Upload your image",
        tips5: "Upload your image",
        tips2: "Upload your image via camera or photo album",
        title4: "Choose hair style",
        tips3: "Choose the hairstyle you like",
        title5: "Generate images",
        tips4: "According to your image and choose a hairstyle, for you to generate a new image",
        tips6: " for you to generate a new image"
    },
    experience: {
        title: "New hair styles",
        title1: "will be created using state-of-the-art AI technologies to identify facial information of a client accurately and effectively, including face shape, hair color, hair length, hair density, sex, skin color, and etc.. The fascinated hair fashion has high fidelity and meets all the expectations of a person. The client who wants to try a new hair style virtually will see hie or her new image through this app.",
        title2: "Online Experience",
        text: "Drag and Drop your image here for upload or press:",
        text1: "CHOOSE IMAGE",
        text2: "facing front no occlusions on face  clear and unobstructed image",
        text3: "Image size: ≤5 M. Image format: jpg, png.",
        text4: "Upload your image on the left.",
        text5: "Choose your favorite hair style on the right.",
        text6: "Click the button New Style to get your new hair style.",
        text7: "New Style",
        text8: "New Style",
    },
    introduce: {
        title: "Core group members",
        title1: "Corporation Objectives",
        title2: "Contact us",
        name: "Charlie",
        name1: "Peng",
        name2: "Fan Li",
        name3: "Eric",
        name4: "Qiqi",
        name5: "Mike",
        nam6: "Ziwei",
        name7: "Steve",
        name8: "Yun Sun",
        text: "Founder",
        text1: "Co-founder",
        text2: "Director of AI Lab",
        text3: "Lead Scientist",
        text4: "Lead Product Manage",
        text5: 'Design leader',
        text6: "Never Forget Why We Started",
        text7: "Pursuit of Perfection",
        text8: "Customer First",
        text9: "Result-oriented Service",
        text10: "Innovate Courageously",
        text11: "Humble and Pragmatic",
        phone: "Phone：400-000-000",
        email: "Email: schz@metastyle.art",
        address: "Address: Room 106 at the fourth floor of Taohui Xintian, Dongcheng District, Beijing, China.",
        content: "Neuralimage was founded in February 2022 and is using the power of artificial intelligence and other emerging technologies for the creation of the metaverse. We provide pioneering solutions for AI editing, virtual production, visual effects, 3D reconstruction and other applications. Our AI-powered platform simplifies and accelerates the process of producing breakthrough content, strengthening artists, enhancing their creativity and enhancing storytelling.",
        content1: "Artificial intelligence editing",
        content2: "Virtual production",
        content3: "Visual effects",
        content4: "3D Reconstruction",
        content5: "Neuralimage by the brightest minds in artificial intelligence, computer vision, and computer graphics. Our co-founders include PHDs in computer vision from New York University, Portland State University, University of Oregon, Prude University, Ohio State University, and Nanyang Technological University.",
        content6: "Join us and grow together"
    },
    join:{
        text:"We will contact you as soon as we receive the demand",
        text1:"Cooperation Enquiry",
        text2:"Name",
        text3:"Please enter your name",
        text4:"Tel",
        text5:"Please enter your mobile phone",
        text6:"Email",
        text7:"Please enter your email",
        text8:"Company",
        text9:"Please enter your company/enterprise name",
        text10:"Detail info",
        text11:"You can briefly describe your needs so that we can arrange relevant personnel to contact you",
        text12:"Enter"
    }
};



// WEBPACK FOOTER //
// ./src/lang/language-en.js